import { useState } from 'react';
import Dialog from '#lib/components/dialog.jsx';
import { Icon } from '@iconify-icon/react';
import toast from 'react-hot-toast';
import Input from '#lib/components/input.jsx';
import { validateStringWithRegex } from '#lib/helpers/regex.js';
import Checkbox from '#lib/components/checkbox.jsx';
import Button from '#lib/components/button.jsx';
import { useClients } from './use-newsletter.js';
import { addClasses } from '#lib/helpers/class.js';

export default function MailListModal(props) {
    const { isOpen, onClose, clients, setClients, id } = props;
    const [mail, setMail] = useState(null);
    const [state, setState] = useState(clients);
    const [inputError, setInputError] = useState(false);
    const handleClose = () => {
        setMail(null);
        setInputError(false);
        setState(null);
        onClose();
    };
    const saveMutation = useClients(handleClose, setClients);
    const addClient = () => {
        if (!mail) return toast.error(_t.global.validation.emailRequired());
        if (!validateStringWithRegex(mail)) {
            setInputError(true);
            return toast.error(_t.global.validation.invalidEmail());
        }
        const updated = structuredClone(state);
        if (updated.find((client) => client.email === mail)) return toast.error(_t.edit.emailExists());
        const contact = {
            email: mail.trim(),
            notify: true
        };
        updated.push(contact);
        setMail(null);
        setState(updated);
    };

    return (
        <Dialog isOpen={isOpen} onClose={handleClose}>
            <Dialog.Panel className="flex flex-col items-end gap-2 m-10 min-w-[300px] w-full max-w-[500px] max-h-[700px]">
                <div className="w-full pr-4">
                    <Dialog.CloseButton />
                    <p className="text-2xl">{_t.edit.clients()}</p>
                    <p className="text-sm text-neutral-700">{_t.edit.addClients()}</p>
                </div>
                <div className="w-full flex items-center gap-2">
                    <Input.Full
                        className="w-full"
                        value={mail || ''}
                        placeholder={_t.edit.fields.email()}
                        onChange={(event) => {
                            setInputError(false);
                            setMail(event.target.value);
                        }}
                        hasError={inputError}
                    />
                    <Button className="flex items-center justify-center rounded-lg bg-neutral-100 p-[6px] border border-neutral-300 hover:bg-primary-100"
                        onClick={addClient}
                    >
                        <Icon
                            icon="material-symbols:add"
                            width={24}
                            height={24}
                            className="text-center cursor-pointer"
                        />
                    </Button>
                </div>
                {state && state.length > 0 && <MailList clients={state} setClients={setState} />}
                <Button
                    look="white"
                    className={addClasses("mt-1")}
                    onClick={() => saveMutation.mutate({ notifications: state, id })}
                    busy={saveMutation.isLoading}
                >
                    {_t.global.save()}
                </Button>
            </Dialog.Panel>
        </Dialog>
    );
}

function MailList(props) {
    const { clients, setClients } = props;
    return (
        <>
            <div className="w-full text-left text-sm p-2 bg-neutral-100 rounded-lg text-neutral-800 border border-neutral-300">
                <span>{_t.edit.mailingDescription()}</span>
            </div>
            <div className="w-full h-full mt-1 flex flex-col gap-2 overflow-y-auto">
                {clients?.map((client, i) => {
                    return (
                        <div
                            className="w-full flex justify-between items-center p-2 bg-neutral-50 rounded-lg border border-neutral-300"
                            key={i}
                        >
                            <div className="flex gap-2 items-center">
                                <Checkbox.Full
                                    checked={client.notify}
                                    onChange={(event) => {
                                        const updated = structuredClone(clients);
                                        updated[i].notify = event.target.checked;
                                        setClients(updated);
                                    }}
                                />
                                <span>{client.email}</span>
                            </div>
                            <Icon
                                icon="ph:trash"
                                width="1.2rem"
                                height="1.2rem"
                                className="ml-2 translate-y-0.5 cursor-pointer"
                                onClick={() => {
                                    const updated = structuredClone(clients);
                                    updated.splice(i, 1);
                                    setClients(updated);
                                }}
                            />
                        </div>
                    );
                })}
            </div>
        </>
    );
}
